import { css, extractShadow, Styles, withStyles } from '@recruit-robin/robin-theme/web-styles';

const styles = {
  modalContent: css`
    min-width: 548px;
    max-width: 548px;
    border-radius: 16px;
    box-shadow: ${extractShadow((s) => s.robin2)};
  `,
  body: css`
    display: flex;
    flex-direction: column;
    gap: 20px;
  `,
  iconContainer: ({ theme }) => css`
    display: flex;
    justify-content: center;
    align-items: center;
    margin: 0 auto 4px;
    color: ${theme.colors.neutral.variant[80]};
  `,
  header: css`
    display: flex;
    flex-direction: column;
    align-items: center;
    gap: 8px;
    text-align: center;
  `,
  checkboxGroup: css`
    display: flex;
    flex-direction: column;
    gap: 14px;
  `,
  textarea: ({ theme }) => css`
    border: 1px solid ${theme.colors.neutral.variant[20]};
    border-radius: 18px;
    background-color: transparent;
    padding: 0;

    & > textarea {
      min-height: 100px;
      background-color: transparent;
      border: none;
      border-radius: 18px;
      padding: 12px 16px;
    }
  `,
  actions: css`
    display: flex;
    justify-content: flex-end;
    align-items: center;
    gap: 16px;
    margin-top: 8px;
  `,
  cancelButton: ({ theme }) => css`
    background: none;
    border: none;
    cursor: pointer;
    font-size: 14px;
    font-weight: 600;
    color: ${theme.colors.neutral.variant[70]};
    padding: 8px 4px;

    &:hover {
      color: ${theme.colors.neutral.variant[80]};
    }
  `,
} satisfies Styles<void>;

export const useStyles = withStyles(styles);
